"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable jsx-a11y/click-events-have-key-events */
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var semantic_ui_react_1 = require("semantic-ui-react");
var SidebarActions_1 = require("../sidebar/SidebarActions");
var userActions_1 = require("../user/userActions");
var actions = __importStar(require("../user/userActions"));
var HeaderLogin_1 = __importDefault(require("./HeaderLogin"));
var react_i18next_1 = require("react-i18next");
var LanguageSelector_1 = __importDefault(require("./LanguageSelector"));
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this.showLoginModal = function () { return _this.setState({ openLoginModal: true }); };
        _this.toggleMenu = function () {
            return _this.setState(function (prevState) { return ({ visible: !prevState.visible }); });
        };
        var theme = window.localStorage.getItem("trybe_theme")
            ? window.localStorage.getItem("trybe_theme")
            : "light";
        _this.state = {
            visible: false,
            openLoginModal: false,
            publishIssue: false,
            lightTheme: theme === "light" ? true : false,
            isDropdown: false,
        };
        return _this;
    }
    Header.prototype.render = function () {
        var toggleSidebarAction = this.props.toggleSidebarAction;
        var pageName = window.location.pathname;
        var menuItems = {
            stars: [
                {
                    name: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "navForCreatorsDropdown" }),
                    link: "/",
                    active: true,
                },
                {
                    name: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "navFitness" }),
                    link: "/fitness",
                    active: true,
                },
                {
                    name: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "navInfluencers" }),
                    link: "/influencer",
                    active: true,
                },
                {
                    name: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "navSports" }),
                    link: "/sports",
                    active: true,
                },
                {
                    name: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "navMusic" }),
                    link: "/music",
                    active: true,
                },
            ],
            types: [
                {
                    name: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "nevTypes" }),
                    link: "/",
                    active: true,
                },
                {
                    name: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "navTypesEvents" }),
                    link: "/events",
                    active: true,
                },
                {
                    name: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "navTypesMembership" }),
                    link: "/private-memberships",
                    active: true,
                },
                {
                    name: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "navTypesDigital" }),
                    link: "/digital",
                    active: true,
                },
                {
                    name: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "navTypesMusic" }),
                    link: "/music",
                    active: true,
                },
                /* {
                  name: "Giveaways",
                  link: "/giveaways",
                  active: false,
                },
                {
                  name: "Merchndise",
                  link: "/",
                  active: false,
                },
                {
                  name: "Metaverse experience",
                  link: "/metaverse",
                  active: false,
                },
                {
                  name: "Tokens and Crypto",
                  link: "/crypto",
                  active: false,
                }, */
            ],
        };
        return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, { children: (0, jsx_runtime_1.jsxs)("header", { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Container, { children: (0, jsx_runtime_1.jsx)("nav", __assign({ className: "navbar navbar-expand-lg navbar-light fixed-top shadow-sm", id: "mainNav" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "container" }, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ className: "navbar-brand fw-bold", to: pageName.includes("stars") ||
                                            pageName.includes("collectibles")
                                            ? "/stars"
                                            : "/" }, { children: (0, jsx_runtime_1.jsx)("img", { src: "/fanslogo2.png", alt: "", width: "100px" }) })), (0, jsx_runtime_1.jsx)("img", { className: "cztoggle-menu-mobile", onClick: function () { return toggleSidebarAction("pages"); }, src: "/menu.svg", alt: "menu" }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "collapse navbar-collapse navbar", id: "navbarResponsive" }, { children: [(0, jsx_runtime_1.jsxs)("ul", __assign({ className: "navbar-nav mr-auto my-3 my-lg-0" }, { children: [(0, jsx_runtime_1.jsx)("li", __assign({ className: "nav-item" }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ className: pageName === "/" ? "nav-link  active" : "nav-link", to: "/" }, { children: (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "navHome" }) }) })) })), (0, jsx_runtime_1.jsx)("li", __assign({ className: "nav-item" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://app.loop.fans/clubs/", className: pageName.includes("clubs") ||
                                                                pageName.includes("fanclubs") ||
                                                                pageName.includes("creator")
                                                                ? "nav-link  active"
                                                                : "nav-link" }, { children: (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "LOOPS" }) }) })) })), (0, jsx_runtime_1.jsx)("li", __assign({ className: "nav-item" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://awards.loop.fans/", className: (pageName.includes("clubs") &&
                                                                pageName.includes("fanclubs")) ||
                                                                pageName.includes("creator")
                                                                ? "nav-link  active"
                                                                : "nav-link" }, { children: (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "musicAwards" }) }) })) })), (0, jsx_runtime_1.jsx)("li", __assign({ className: "nav-item" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://app.loop.fans", className: pageName.includes("stars")
                                                                ? "nav-link  active"
                                                                : "nav-link" }, { children: (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "membersArea" }) }) })) }))] })), (0, jsx_runtime_1.jsx)(LanguageSelector_1.default, {}), (0, jsx_runtime_1.jsx)(HeaderLogin_1.default, { isAuthorized: this.props.isAuthorized, logout: this.props.logout, address: this.props.address })] }))] })) })) }), (0, jsx_runtime_1.jsx)("div", { className: "progress-loop" })] }) }));
    };
    return Header;
}(react_1.default.Component));
exports.default = (0, react_router_dom_1.withRouter)((0, react_redux_1.connect)(function (state) { return ({
    userInfo: state.user.userInfo,
}); }, function (dispatch) { return ({
    toggleSidebarAction: function (params) {
        console.log(params);
        dispatch((0, SidebarActions_1.toggleSidebar)(params));
    },
    getUserData: function () {
        dispatch(actions.getUserData());
    },
    resetModal: function () {
        dispatch((0, userActions_1.returnToLoginMode)());
    },
}); })(Header));
